/* eslint-disable react/prop-types */
const FormErrors = ({ errors }) => {
  return (
    <div className="mb-10">
      {Object.keys(errors).map((key) => (
        <p
          className="text-red-700 text-center items-center justify-center my-3 p-4 rounded-md text-sm bg-red-100 border border-red-300"
          key={key}
        >
          {errors[key][0]}
        </p>
      ))}
    </div>
  );
};

export default FormErrors;
